import Cookies from 'js-cookie'
import enviroment from '../enviroment';

export default {
    setToken(token) {
        Cookies.set('STRATEGY_TOKEN', token, {
            domain: enviroment.cookiesDomain,
            path: '/'
        })
    },
    getToken () {
        return Cookies.get('STRATEGY_TOKEN');
    },
    clearToken () {
        Cookies.remove('STRATEGY_TOKEN');
    }
}